import { Component } from '@angular/core';

@Component({
  selector: 'web-penny-drop-shimmer',
  templateUrl: './penny-drop-shimmer.component.html',
  styleUrls: ['./penny-drop-shimmer.component.scss']
})
export class PennyDropShimmerComponent {

}
